import React, { useRef } from 'react';
import { InputGroup, Form } from 'rsuite';
import InputBase from './InputBase';
import { NumericFormatter } from './NumericFormatter';

const LabeledInputWithSymbol = ({
    label,
    type = 'text',
    defaultValue,
    placeholder,
    symbolIcon,
    infoText,
    infoTextTooltip,
    onChange,
    name,
    rule,
    value,
    formatNumeric = true,
    disabled,
    helpText,
    autoFocus,
    alignLeft,
    isIndentedInput,
    hideInfoIcon,
    addon,
    readOnly,
    hasCheckbox,
    checkboxChecked
}) => {
    const containerRef = useRef();

    // hide validation error message
    onChange = () => {
        const container = containerRef.current;
        container.classList.add('hide-error-msg');
    };
    return (
        <InputBase
            label={label}
            showRequired={rule?.required}
            infoText={infoText}
            infoTextTooltip={infoTextTooltip}
            isIndentedInput={isIndentedInput}
            hideInfoIcon={hideInfoIcon}
            hasCheckbox={hasCheckbox}
            checkboxChecked={checkboxChecked}
            readOnly={readOnly}>
            <Form.Group data-testid="form-group">
                <InputGroup className="custom-input-1">
                    {addon && <InputGroup.Addon className="prefix">{addon}</InputGroup.Addon>}
                    <Form.Control
                        ref={containerRef}
                        name={name}
                        className={type === 'text' || alignLeft ? 'align-left' : 'align-right'}
                        defaultValue={defaultValue}
                        placeholder={placeholder}
                        onChange={onChange}
                        autoFocus={autoFocus}
                        type={type === 'number' && formatNumeric ? 'text' : type}
                        rule={rule}
                        value={value}
                        errorPlacement="bottomEnd"
                        disabled={disabled}
                        accepter={type === 'number' && formatNumeric ? NumericFormatter : undefined}
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck="off"
                        data-testid={name}
                        readOnly={readOnly}
                    />
                    {symbolIcon && (
                        <InputGroup.Addon className="custom-input-1-icon">
                            {symbolIcon}
                        </InputGroup.Addon>
                    )}
                </InputGroup>
                {helpText && <Form.HelpText>{helpText}</Form.HelpText>}
            </Form.Group>
        </InputBase>
    );
};

export default LabeledInputWithSymbol;
